import { Component } from '@angular/core';
import { ComponentNotes, ComponentPart, Components, ReleaseRetrievalService } from 'src/app/services/apiHandler/release-retrieval/release-retrieval.service';

@Component({
  selector: 'app-components',
  templateUrl: './components.component.html',
  styleUrls: ['./components.component.scss']
})
export class ComponentsComponent {

  public components: ComponentPart[] = [];
  public expandedArray: boolean[] = [];
  public versionNotes!: ComponentNotes;
  public error: boolean = false;
  public allExpanded: boolean = false;

  
  constructor(private releaseRetrievalService: ReleaseRetrievalService) {
    releaseRetrievalService.getComponentList().subscribe({
      next: (res) => {
        let allComp: Components = JSON.parse(JSON.stringify(res.body));
        this.components = allComp.components;
        this.components.forEach(() => {this.expandedArray.push(false);});
      }, error: () => {
          this.error = true;
        }
    });
  }

  public toggleBtn(index: number, name: string) {
    this.expandedArray[index] = !this.expandedArray[index];
    this.checkExpansion();
    if(this.expandedArray[index] && this.components[index].component === undefined ) {
      this.components[index].loaded = false;
      this.releaseRetrievalService.getComponentNotes(name).subscribe({
        next: (resp) => {
          this.versionNotes = JSON.parse(JSON.stringify(resp.body));
          this.components[index].component = this.versionNotes;
          this.components[index].loaded = true;
        },error: () => {
          this.components[index].loaded = true;
          this.components[index].error = true;
        }
      });
    }
  }

  private checkExpansion() {
    if(this.expandedArray.every((el) => el === true)) {
      this.allExpanded = true;
    } else if(this.expandedArray.every((el) => el === false)) {
      this.allExpanded = false;
    }
  }

  public toggleExpansion() {
    this.allExpanded = !this.allExpanded;
    if(this.allExpanded) {
      this.components.forEach((comp, index) => {
        this.expandedArray[index] = false;
        this.toggleBtn(index, comp.componentName);
      }); 
    } else {
      this.components.forEach((comp, index) => {
        this.expandedArray[index] = true;
        this.toggleBtn(index, comp.componentName);
      });
    }    
  }

}
